import hostname from "../api/config.host";
import { fetchWrapper } from "../api/fetch-wrapper";
const apiUrl: string = `${hostname}/aladdin_api/v1`;

interface QueriesInBizLeaderDashboardParams {
  oauthTokenHeader: string;
  queryId: string;
  websiteSharedUids: string[]; // Multiple
  type: string;
  dimension: string[];
  start_date?: string;
  end_date?: string;
}

function getQueriesInBizLeaderDashboardMobile(
  params: QueriesInBizLeaderDashboardParams,
) {
  const {
    oauthTokenHeader,
    queryId,
    websiteSharedUids = [],
    type,
    dimension = [],
    start_date,
    end_date,
  } = params;
  const searchParams = new URLSearchParams();
  websiteSharedUids.forEach((uid) =>
    searchParams.append("website_shared_uid", uid),
  );
  if (start_date) {
    searchParams.append("start_date", start_date);
  }
  if (end_date) {
    searchParams.append("end_date", end_date);
  }
  if (type) {
    searchParams.append("type", type);
  }
  dimension.forEach((dim) => {
    searchParams.append("dimension", dim);
  });
  const fullUrl = `${apiUrl}/biz_layer_query/run/${queryId}/?${searchParams.toString()}`;
  return fetchWrapper.get(fullUrl, oauthTokenHeader);
}

function getQueriesInBizLeaderDashboardMobileWithDates(
  params: QueriesInBizLeaderDashboardParams,
) {
  const {
    oauthTokenHeader,
    queryId,
    websiteSharedUids = [],
    type,
    dimension = [],
    start_date,
    end_date,
  } = params;
  const searchParams = new URLSearchParams();
  websiteSharedUids.forEach((uid) =>
    searchParams.append("website_shared_uid", uid),
  );
  if (type) {
    searchParams.append("type", type);
  }
  dimension.forEach((dim) => {
    searchParams.append("dimension", dim);
  });
  if (start_date) {
    searchParams.append("start_date", start_date);
  }
  if (end_date) {
    searchParams.append("end_date", end_date);
  }
  const fullUrl = `${apiUrl}/biz_layer_query/run/${queryId}/?${searchParams.toString()}`;
  return fetchWrapper.get(fullUrl, oauthTokenHeader);
}

function getDimensionInBizLeaderDashboardMobile(oauthTokenHeader: string) {
  return fetchWrapper.get(
    `${apiUrl}/asset_management/dimensions/`,
    oauthTokenHeader,
  );
}

function getTargetVsActualPR(
  oauthTokenHeader: string,
  queryId: string,
  startDate: string,
  endDate: string,
  type: string,
  websiteSharedUid: string[] = [],
  dimension: string[] = [],
) {
  const searchParams = new URLSearchParams();

  // Required params
  if (startDate) {
    searchParams.append("start_date", startDate);
  }

  if (endDate) {
    searchParams.append("end_date", endDate);
  }

  // Multiple website_shared_uid
  websiteSharedUid.forEach((uid) => {
    searchParams.append("website_shared_uid", uid);
  });

  // Multiple dimension
  dimension.forEach((dim) => {
    searchParams.append("dimension", dim);
  });

  if (type) {
    searchParams.append("type", type);
  }

  const fullUrl = `${apiUrl}/biz_layer_query/run/${queryId}/?${searchParams.toString()}`;

  return fetchWrapper.get(fullUrl, oauthTokenHeader);
}
export const bizLeaderDashboardMobileService = {
  getQueriesInBizLeaderDashboardMobile,
  getDimensionInBizLeaderDashboardMobile,
  getQueriesInBizLeaderDashboardMobileWithDates,
  getTargetVsActualPR,
};
